import { makeVar } from "@apollo/client";

const SignUpSignInRedirectKey = "pre-register-redirect";
const reactiveVar = makeVar<string>("");

export default {
  var: reactiveVar,
  update(value: Partial<string>) {
    localStorage.setItem(SignUpSignInRedirectKey, value);
    return reactiveVar(value);
  },
  read() {
    return reactiveVar();
  },
};
